import { Link } from "react-router-dom";
import { Boxes, Cpu, HardDrive, Brain, Code2, Coins, ArrowUpRight } from "lucide-react";

const PRODUCTS = [
    { to: "/layer-1", icon: Boxes, title: "Layer-1 EVM Chain", body: "EVM-compatible settlement layer for nodes, workloads, payments, DNS, and proofs.", tag: "Settlement" },
    { to: "/nodes", icon: Cpu, title: "DePIN Node Economy", body: "Run a node — compute, GPU, storage, validator — and earn from real network usage.", tag: "Supply Side" },
    { to: "/ai-compute", icon: Brain, title: "AI Compute", body: "An open GPU marketplace for inference, model hosting, and fine-tuning workloads.", tag: "GPU Market" },
    { to: "/storage", icon: HardDrive, title: "Encrypted Storage", body: "Client-side AES-256-GCM + Reed-Solomon 16/10 + Proof of Storage on-chain.", tag: "Sovereign Data" },
    { to: "/developers", icon: Code2, title: "Developer Platform", body: "Solidity contracts, SDKs, CLI, APIs, explorer — build cloud-native dApps.", tag: "Demand Side" },
    { to: "/token", icon: Coins, title: "$DCX Utility", body: "Gas, staking, settlement, governance, rewards, developer revenue share.", tag: "Economy" },
];

export default function ProductCards() {
    return (
        <section className="relative py-16 sm:py-24 md:py-32 lg:py-40 border-t border-line" data-testid="product-cards-section">
            <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
                <div className="max-w-3xl mb-10 sm:mb-16">
                    <div className="overline mb-4">Ecosystem</div>
                    <h2 className="font-heading font-black text-[1.85rem] sm:text-4xl lg:text-5xl leading-[1.06] tracking-tight text-ink">
                        The DeCloudX <span className="brand-gradient-text">Protocol Stack.</span>
                    </h2>
                    <p className="mt-5 sm:mt-6 text-[15px] sm:text-base text-muted-ink max-w-2xl leading-relaxed">
                        One coordinated cloud protocol — six product surfaces. Pick an entry point and explore how compute, storage, AI, settlement, and the developer economy fit together.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {PRODUCTS.map((p, i) => (
                        <Link key={i} to={p.to} className="group surface card-lift p-5 sm:p-7 rounded-2xl block" data-testid={`product-card-${i}`}>
                            <div className="flex items-start justify-between mb-4 sm:mb-5">
                                <div className="w-11 h-11 rounded-xl bg-card-muted border border-line flex items-center justify-center">
                                    <p.icon size={19} className="text-brand-blue" strokeWidth={1.5} />
                                </div>
                                <ArrowUpRight size={18} className="text-faint-ink group-hover:text-brand-blue group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" strokeWidth={1.5} />
                            </div>
                            <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-faint-ink">{p.tag}</div>
                            <h3 className="font-heading font-bold text-base sm:text-lg text-ink mt-1.5">{p.title}</h3>
                            <p className="text-[13.5px] sm:text-sm text-muted-ink mt-2.5 leading-relaxed">{p.body}</p>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
